import { Text } from "@chakra-ui/react";
import { ColumnDefWithTooltip } from "src/components/Table/Table";
import { ColumnId } from "./constants";

type Row = {
  schoolForm: { id: string; overrideReason?: string | null } | null;
};
export function buildOverrideReasonColumnDef<
  T extends Row
>(): ColumnDefWithTooltip<T> {
  return {
    accessorFn: (row) => row.schoolForm?.overrideReason,
    id: ColumnId.OverrideReason,
    header: "Override reason",
    cell: (props) =>
      props.row.original.schoolForm?.overrideReason ?? (
        <Text variant="placeholder">No reason</Text>
      ),
  };
}
